module.exports = __webpack_public_path__ + "img/ao.d31432cd.svg";